/**
 * 手机号有号段检测
 */
export const PHONE_REG = /^1[3456789]\d{9}$/;
